import type { ComponentPropsWithRef } from "react";

import { cn } from "../../lib/cn";

export function Input({ className, type, ...props }: ComponentPropsWithRef<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-9 w-full rounded-control border border-outline bg-surface-container px-3 py-1 text-sm text-on-surface shadow-sm transition-colors",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-on-surface",
        "placeholder:text-on-surface-muted",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:border-focus-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-error aria-invalid:ring-error",
        className,
      )}
      {...props}
    />
  );
}
